const GENERIC_MESSAGE = 'No se pudo completar la operación. Intente nuevamente.';

type ApiErrorLike = {
	response?: { data?: { detail?: unknown; title?: unknown } };
};

const asText = (value: unknown): string | undefined =>
	typeof value === 'string' && value.trim() !== '' ? value : undefined;

// El BE responde los errores como RFC 7807 (`detail` / `title`), no con `message`.
export const getApiErrorMessage = (error: unknown, fallback: string = GENERIC_MESSAGE): string => {
	const data = (error as ApiErrorLike)?.response?.data;

	return asText(data?.detail) ?? asText(data?.title) ?? fallback;
};
